/* ============================================================
   RF Main V4 - controller
============================================================ */

window.PEMRF_V5 = {
  currentStep: 0,
  answers: {
    age: null,
    skin_type: null,
    concerns: [],
    eye_area: null,
    cleanser: null
  },
  maxConcerns: 2,
  __scores: {}
};

document.addEventListener("DOMContentLoaded", () => {
  if (typeof window.PEMRF_PRODUCTS_V5 === "undefined") return;
  
  /* ============================================================
     CHECK FOR SAVED RESULT STATE (back button navigation)
  ============================================================ */
  try {
    const savedState = sessionStorage.getItem('pemrf_v5_result_state');
    if (savedState) {
      const state = JSON.parse(savedState);
      
      // Restore state
      window.PEMRF_V5.__scores = state.scores;
      window.PEMRF_V5.answers = state.answers;
      window.PEMRF_V5.selectedIconicLips = state.selectedIconicLips;
      
      // Render result page immediately
      pemrf_v5_renderResult(state.scores);
      return;
    }
  } catch (e) {
    console.warn('Could not restore result state:', e);
  }
  
  // Normal flow: start quiz
  pemrf_v5_renderQuestions();
});